/*
  Строка блока «Месяцы с начислениями из двух источников» (01.10.2026): счёт,
  месяц, что записано в портфеле и что в файле - услугами, суммами и итогом.
  Если заменить месяц нельзя (он вошёл в поданные или готовые к подаче
  документы), причина стоит в строке словами сервера.

  Только разметка: всё приходит пропсами (`MonthChoices`).
*/

import { Link } from 'react-router-dom'

import { chargeMonth, money } from '../../api/format.js'
import { Check } from '../Common.jsx'

export default function MonthRow({ item, checked, onToggle }) {
  const month = chargeMonth(item.period)
  return (
    <tr>
      <td className="table__control">
        <Check checked={checked} onChange={onToggle} title={`Отметить счёт ${item.account_number} за ${month}`} />
      </td>
      <td>
        <Link to={`/accounts/${item.account_id}`}>№ {item.account_number}</Link>
      </td>
      <td data-label="Месяц">{month}</td>
      <td data-label="Записано в портфеле" className="table__block">
        <MonthSide side={item.portfolio} empty="Сейчас за месяц ничего не записано." />
      </td>
      <td data-label="В файле" className="table__block">
        <div>
          <div className="muted filename">«{item.filename}»</div>
          <MonthSide side={item.file} empty="Строк нет." />
          {item.can_replace ? null : (
            <div className="months__refusal">Заменить нельзя: {item.refusal}</div>
          )}
        </div>
      </td>
    </tr>
  )
}

function MonthSide({ side, empty }) {
  if (!side.lines.length) return <div className="muted">{empty}</div>
  return (
    <div>
      <ul className="months__lines">
        {side.lines.map((line) => (
          // Услуга в месяце одна на строку - и в портфеле, и в файле: её название
          // и есть ключ.
          <li key={line.service} className="months__line">
            <span>{line.service}</span>
            <span className="months__sum">{money(line.charged)}</span>
            {Number(line.paid) ? <span className="months__paid">оплачено {money(line.paid)}</span> : null}
          </li>
        ))}
      </ul>
      <div className="months__total">
        Итого {money(side.charged)}, оплачено {money(side.paid)}
      </div>
    </div>
  )
}
